import { RuleAlias } from './RuleAlias';
export default class Rule {
    alias;
    actionName;
    resourceToModify;
    constructor(rule = {}) {
        Object.assign(this, rule);
    }
    isAllowed(aliases) {
        return aliases.includes(RuleAlias.MANAGE_ALL) || aliases.includes(this.alias);
    }
}
//# sourceMappingURL=Rule.js.map